import { render, staticRenderFns } from "./TheorySignatureModal.vue?vue&type=template&id=70e48000&"
import script from "./TheorySignatureModal.vue?vue&type=script&lang=ts&"
export * from "./TheorySignatureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports